"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.getWithinViewport = exports.getExtendedViewport = void 0;
exports.getExtendedViewport = function (viewport) {
    var oldBound = viewport.bound;
    var newBound = {
        ne: {
            lat: oldBound.ne.lat + ((oldBound.ne.lat - oldBound.sw.lat) / 5),
            lng: oldBound.ne.lng + ((oldBound.ne.lng - oldBound.sw.lng) / 5)
        },
        sw: {
            lat: oldBound.sw.lat - ((oldBound.ne.lat - oldBound.sw.lat) / 5),
            lng: oldBound.sw.lng - ((oldBound.ne.lng - oldBound.sw.lng) / 5)
        }
    };
    return __assign(__assign({}, viewport), { bound: newBound });
};
exports.getWithinViewport = function (pins, viewport) {
    var extendedViewport = exports.getExtendedViewport(viewport);
    return pins
        .filter(function (it) { return it.lat < extendedViewport.bound.ne.lat; })
        .filter(function (it) { return it.lat > extendedViewport.bound.sw.lat; })
        .filter(function (it) { return it.lng < extendedViewport.bound.ne.lng; })
        .filter(function (it) { return it.lng > extendedViewport.bound.sw.lng; });
};
